import axios from 'axios';

// CALLS THAT STOP CAN CANCEL (Louis 2026-11-03).
//
// Every POST to the NoticeIA API carries an id (X-Notice-Call), and the ids still out are kept
// here. Stop sends them to the server, which cancels each call still polling OpenAI at its next
// poll (see notice._ask_on_images): a call in OpenAI's queue costs nothing, and one thinking
// stops being billed. The request then answers 409 {stopped: true} — see isStopped.
//
// Per TAB, not per document: a tab shows one document, and Stop is that document's.
const HEADER = 'X-Notice-Call';
const STOP_URL = '/api/notice/calls/stop';
const out = new Set<string>();

const isNoticePost = (url?: string, method?: string) =>
  method === 'post' && !!url && url.includes('/api/notice/') && !url.includes(STOP_URL);

axios.interceptors.request.use((config) => {
  if (!isNoticePost(config.url, config.method)) return config;
  // A retried request (a refreshed session, see NoticeAuthContext) keeps its id.
  let id = config.headers.get(HEADER);
  if (typeof id !== 'string') {
    id = crypto.randomUUID();
    config.headers.set(HEADER, id);
  }
  out.add(id);
  return config;
});

const landed = (config?: { headers?: { get?: (k: string) => unknown } }) => {
  const id = config?.headers?.get?.(HEADER);
  if (typeof id === 'string') out.delete(id);
};
axios.interceptors.response.use(
  (response) => {
    landed(response.config);
    return response;
  },
  (error) => {
    landed(error?.config);
    return Promise.reject(error);
  },
);

// Cancel every call this tab still has out. Fire and forget: a stop that fails leaves the calls
// to land, which is what Stop did before.
export function cancelCalls() {
  if (!out.size) return;
  void axios.post(STOP_URL, { ids: [...out] }).catch(() => {});
}

// Whether a failed request is a call Stop cancelled — not an error to show.
export const isStopped = (e: unknown): boolean =>
  axios.isAxiosError(e) && (e.response?.data as { stopped?: boolean } | undefined)?.stopped === true;
